import { Children, cloneElement, forwardRef, isValidElement } from 'react';
import { ReactChildren } from 'src/shared/types/util.types';

interface PageMainProps extends ReactChildren {
  excludeMaxWidth?: boolean;
  removePadding?: boolean;
}

export default forwardRef<HTMLDivElement, PageMainProps>(function PageMain(
  { children, excludeMaxWidth = false, removePadding = false },
  ref
) {
  return (
    <div
      ref={ref}
      className="w-full h-screen max-h-screen grid"
      style={{
        gridTemplateAreas: `
          "topBar"
          "header"
          "main"
        `,
        gridTemplateRows: 'auto auto 1fr',
      }}
    >
      {Children.map(children, (child) =>
        isValidElement(child) ? cloneElement(child, { excludeMaxWidth, removePadding } as PageMainProps) : child
      )}
    </div>
  );
});
